import { CollaboratorCatalogOrderByEnum } from '@/generated/graphql/types';

import type { TDataSlice } from '../../types';
import { useLearningUserCatalogCoursesQueryQuery } from './learning-user-catalog-courses-query.v5.generated';

const CATALOG_COURSES_COUNT = 5;

export const useCollaboratorCatalogCourses = (organizationId: number) => {
  const { data, loading } = useLearningUserCatalogCoursesQueryQuery({
    variables: {
      input: {
        organization_id: organizationId,
        order_by: CollaboratorCatalogOrderByEnum.Newest,
        first: CATALOG_COURSES_COUNT,
      },
    },
    skip: !organizationId,
    context: { clientName: 'v5' },
  });

  const edges = data?.course.get_collaborator_catalog_courses.edges ?? [];
  const catalogCourses: TDataSlice[] = edges.map(({ node }) => ({
    title: node.title,
    teacher: node.professor_name ?? undefined,
    promoImage: node.image_url,
    duration: node.duration ?? undefined,
    isEnrollment: node.is_enrolled,
    url: node.content_url,
    dashboardUrl: node.content_url,
    lastVideoLectureUrl: node.is_enrolled
      ? node.content_url
      : node.enrollment_url,
  }));

  return { catalogCourses, loading };
};
